<template>
    <div class="device-type-manange relative expert-list">
        <el-page-header @back="goBack" content="专家出诊时间"></el-page-header>
        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">姓名：</span>
                <el-input v-model="user_name" placeholder="姓名模糊搜索"/>
            </el-col>
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">单位：</span>
                <el-select class="search_select"
                    @visible-change="selectShow"
                    filterable
                    clearable
                    v-model="hospital" placeholder="请选择单位" style="width: 100%; max-width: none !important;">
                    <el-option
                        data-flg
                        v-for="item in hospitals"
                        :key="item.id"
                        :label="item.hospital_nick_name"
                        :value="item.hospital_nick_name"
                    ></el-option>
                </el-select>

            </el-col>
        </el-row>
        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">职称：</span>
                <el-select
                    @visible-change="selectShow"
                    filterable
                    clearable
                    v-model="doctor_title" placeholder="请选择职称" style="width: 100%; max-width: none !important;">
                    <el-option
                        data-flg
                        v-for="item in titles"
                        :key="item.id"
                        :label="item.title_name"
                        :value="item.title_name"
                    ></el-option>
                </el-select>
            </el-col>
            <el-col :md="6" :lg="4" :xl="4"  :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">科室：</span>
                <el-select
                    @visible-change="selectShow"
                    filterable
                    clearable
                    v-model="hospital_department" placeholder="请选择科室" style="width: 100%; max-width: none !important;">
                    <el-option
                        data-flg
                        v-for="item in departments"
                        :key="item.id"
                        :label="item.department_name"
                        :value="item.department_name"
                    ></el-option>
                </el-select>
            </el-col>
            <el-col :md="6" :lg="4" :xl="4"  :sm="12" :xs="24">
                <el-button @click="resetForm">重置</el-button>
                <el-button @click="search">筛选</el-button>
            </el-col>
        </el-row>
        <div style="display: flex; flex-wrap: wrap">
            <el-col class="expertCard_wrap" :md="24" :lg="12" :xl="24" :sm="24" :xs="24" v-for="item in tableData" :key="item.use_id">
                <el-form label-position="right" :model="visitForm" :rules="visitsRules" ref="visitForm" label-width="90px"
                         class="form"
                         style="width: 99%;margin: 10px auto 0 auto;border: 1px solid #f3efef;" autocomplete="off">
                    <div class="el-form-item__content">
                        <div class="expert_visit_time_container">
                            <div class="visit_avatar" style="width: 13.9%;margin: auto 1.5% auto 0;">
                                <el-avatar class="visit_avatar_img" style="width: 100%;height: auto;"
                                    :src="item.user_avatar"
                                >
                                </el-avatar>
                                <div class="visit_avatar_content">{{ item.user_name }}</div>
                                <div class="visit_avatar_content desc">{{ item.doctor_title }}</div>
                                <div class="visit_avatar_content desc">{{ item.hospital }}</div>
                            </div>
                            <div class="visit_time_box" v-for="(dat, i) in item.visits_data">
                                <!-- 周一到周五 -->
                                <div :class="dat.header_class" >
                                    <div>{{ dat.week }}</div>
                                </div>
                                <div :class="dat.am_class" @dblclick="editVisits(item, dat, '上午')" :title="dat.am_address">
                                    <div class="half_div" v-if="dat.am_address || dat.am_department">上午</div>
                                    <div v-else> </div>
                                    <div class="address_name">{{ dat.am_address }}</div>
                                </div>
                                <div :class="dat.pm_class" @dblclick="editVisits(item, dat, '下午')" :title="dat.pm_address">
                                    <div class="half_div" v-if="dat.pm_address || dat.pm_department">下午</div>
                                    <div v-else> </div>
                                    <div class="address_name">{{ dat.pm_address }}</div>
                                </div>
                            </div>
                        </div>

                    </div>
                </el-form>
            </el-col>
        </div>

        <el-pagination
            class="mg-20 ta-r"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[12, 30, 60, 120]"
            :total="total"
            :page-size="perpage"
            :current-page="page"
            @current-change="changePage"
            @size-change="changeSite"
            v-if="is_pagination_show"
        ></el-pagination>

        <el-dialog class="visit_data" :title="visit_title" :visible.sync="visitVisible"
                   style="margin: 0 auto;"
                   :before-close="visitsFormRest"
        >
            <el-form label-position="right" :model="visitForm" ref="visitsRules"
                     label-width="75px"
                     style="width: 90%;margin: 0px auto;"
                     class="form" autocomplete="off">
                <el-form-item label="出诊时间">
                    <el-input type="text" v-model="visitForm.visit_time" placeholder="请输入出诊时间" autocomplete="off"
                              @change="updateVisit"
                              clearable
                              style="width: 100%;"></el-input>
                </el-form-item>
                <el-form-item label="出诊地点">
                    <el-input type="text" v-model="visitForm.address" placeholder="请输入出诊地点" autocomplete="off"
                              style="width: 100%;"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer" style="clear: both;">
                <el-button @click="visitVisible = false">取 消</el-button>
                <el-button type="primary" @click="addVisitData">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import env from "@/api/env";
import {export2Excel} from "@/utils/excel";
import {check} from "@/utils/checkData";

import {loadFile, base64Parser, getBase64Image, authUrlCheck, isMobile} from "@/api/order"

// export word
import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import PizZipUtils from "pizzip/utils/index.js";
import {saveAs} from "file-saver";
import ImageModule from "docxtemplater-image-module-free"
import {getUserInfos} from "@/utils/userInfos";
import {getFormatDate} from "@/utils/date";

export default {
    data() {
        return {
            role_id: 0,
            imgUrl: env.IMG_COMMON_URL_PREFIX,
            page: 1,
            perpage: 12,
            total: 0,
            tableData: [],
            is_max_client: "",
            user_name: "",
            hospital: "",
            doctor_title: "",
            hospital_department: "",
            allTitle: [],
            allHospital: [],
            allDeparment: [],
            all_expert: [],
            allStatus: [
                {
                    id: 1,
                    name: "已满",
                },
                {
                    id: 2,
                    name: "未满",
                },
            ],
            half: [
                {
                    id: 1,
                    name: "上午",
                },
                {
                    id: 2,
                    name: "下午",
                },
                {
                    id: 3,
                    name: "全天",
                },
            ],
            is_pagination_show: true,
            hospitals: [
                // {hospital_name: "健康一院"},
            ],
            departments: [
                // {department_name: "消化内科"},
            ],
            titles: [
                // {title_name: "副主任医师"},
            ],

            button_position: 'absolute',
            is_mobile: false,
            carousel_arrow: "hover",
            expert_ids: [],
            is_cancle: 1,
            intertimer:null,
            expertcard_width:"60%",
            visitForm: {
                expert_id: "",
                user_name: "",
                visit_date: "",
                week: "",
                half: "",
                address: "",
                visit_time:"",
                // visit_dates:[
                //     // 固定结构
                //     {"week":"周一","key":"mon","half":"","address":""},
                //     {"week":"周二","key":"tue","half":"","address":""},
                //     {"week":"周三","key":"wen","half":"","address":""},
                //     {"week":"周四","key":"thu","half":"","address":""},
                //     {"week":"周五","key":"fri","half":"","address":""},
                //     {"week":"周六","key":"sat","half":"","address":""},
                //     {"week":"周日","key":"sun","half":"","address":""},
                // ]
            },
            visitsRules: {
                doctor_id: [{required: true, message: "缺少专家ID", trigger: "blur"}],
                address_id: [
                    {required: true, message: "请选择排班地址", trigger: "blur"},
                ],
                visit_dates: [
                    {required: true, message: "请选择签约日期", trigger: "blur"},
                ],
            },
            visit_title:"出诊时间",
            week_day_array:[
                {"week":"周一","key":"mon"},
                {"week":"周二","key":"tue"},
                {"week":"周三","key":"wen"},
                {"week":"周四","key":"thu"},
                {"week":"周五","key":"fri"},
                {"week":"周六","key":"sat"},
                {"week":"周日","key":"sun"},
            ],
            visitVisible: false,
            address_sync: true,
        };
    },
    created() {
        if (isMobile()) {
            this.button_position = 'static'
            this.is_mobile = true
            this.carousel_arrow = 'always'
        }
        this.clientWidth = document.documentElement.clientWidth
        this.clientHeight = document.documentElement.clientHeight
    },
    mounted() {
        let prev_page = localStorage.getItem('prev_page');
        if (prev_page == 'expert_detail' || prev_page == 'expert_add') {
            this.user_name = localStorage.getItem('expert_list_user_name')
            this.doctor_title = localStorage.getItem('expert_list_doctor_title')
            this.hospital = localStorage.getItem('expert_list_hospital')
            this.hospital_department = localStorage.getItem('expert_list_hospital_department')
            this.is_max_client = localStorage.getItem('expert_list_is_max_client')
            this.page = parseInt(localStorage.getItem('page'))
            this.perpage = parseInt(localStorage.getItem('perpage'))
            if (this.user_name == 'undefined' || this.user_name == 'null') {
                this.user_name = ''
            }
            if (this.doctor_title == 'undefined' || this.doctor_title == 'null') {
                this.doctor_title = ''
            }
            if (this.hospital == 'undefined' || this.hospital == 'null') {
                this.hospital = ''
            }
            if (this.hospital_department == 'undefined' || this.hospital_department == 'null') {
                this.hospital_department = ''
            }
            if (this.is_max_client == 'undefined' || this.is_max_client == 'null') {
                this.is_max_client = ''
            }
            this.is_pagination_show = false
        }

        //获取专家列表
        this.getList();
        this.getManualParams();

        // this.getExpertInfo();
        let userInfo = getUserInfos()
        if (userInfo) {
            this.role_id = parseInt(userInfo.role_id)
        }

    },
    methods: {
        getManualParams() {
            let params = {
                servername: "Ruyi_AdminDoctorServices",
                method: "getManualSearchParams",
            };

            this.$api.service(params).then((res) => {
                if (!check(res)) {
                    return;
                }

                this.hospitals = res.data.data.hospitals
                this.departments = res.data.data.departments
                this.titles = res.data.data.titles
            });
        },
        clearVisits() {
            for (let j = 0; j < this.visitForm.visit_dates.length; j++) {
                if (!this.visitForm.visit_dates[j].half) {
                    this.visitForm.visit_dates[j].address = ""
                    break;
                }
            }
        },
        halfChange(e, index) {
            if (!this.address_sync)return;
            let address = ''
            for (let j = 0; j < this.visitForm.visit_dates.length; j++) {
                if (this.visitForm.visit_dates[j].half && this.visitForm.visit_dates[j].address) {
                    address = this.visitForm.visit_dates[j].address
                    break;
                }
            }
            if (e) {
                this.addressChange(address, index)
            } else {
                this.addressChange(address, index, 1)
            }
        },
        // 清除地址取消同步
        addressClear(event, index) {
           this.address_sync = false
        },
        // 地址同步
        addressChange(e, index, clear_half = 0) {
            if (clear_half) {
                this.visitForm.visit_dates[index].address = ""
                return;
            }
            if (!this.visitForm.visit_dates[index].half) {
                this.$message({
                    type: "warning",
                    message: '请先选择出诊时间！',
                    duration: 1500,
                });
                this.visitForm.visit_dates[index].address = ""
                return;
            }
            for (let j = 0; j < this.visitForm.visit_dates.length; j++) {
                if (j != index
                    && this.visitForm.visit_dates[j].half
                    && this.visitForm.visit_dates[j].address
                    && e.indexOf(this.visitForm.visit_dates[j].address) < 0
                ) {
                    this.address_sync = false
                }
            }
            if (!this.address_sync)return;
            for (let j = 0; j < this.visitForm.visit_dates.length; j++) {
                if (this.visitForm.visit_dates[j].half) {
                    this.visitForm.visit_dates[j].address = e
                }
            }
        },
        visitsFormRest(){
            this.visit_title = ""
            this.visitForm.visit_date = ""
            this.visitForm.half = ""
            this.visitForm.address = ""
            this.visitForm.visit_time = ""
            this.visitForm.user_name = ""
            this.visitVisible = false
        },
        editVisits(data, visitdata, half) {
            let address = '';
            if (half === '上午') {
                address = visitdata.am_address
            } else if(half === '下午') {
                address = visitdata.pm_address
            }
            this.visitsFormRest()
            let msg = `是否修改 ${data.user_name} ${visitdata.week}${half}的出诊时间`
            this.$confirm(msg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.visit_title = `${data.user_name}：${data.hospital}——${data.hospital_department}`
                this.visitForm.expert_id = data.user_id
                this.visitForm.visit_date = visitdata.week_key
                this.visitForm.week = visitdata.week
                this.visitForm.user_name = data.user_name
                this.visitForm.address = address
                this.visitForm.half = half
                this.visitForm.visit_time = this.visitForm.week + this.visitForm.half
                this.visitVisible = true
            }).catch((e) => {
                console.log(e)
            })
        },
        //重置表单
        resetForm() {
            this.user_name = "";
            this.doctor_title_id = "";
            this.doctor_title = "";
            this.hospital_id = "";
            this.hospital_department_id = "";
            this.hospital_department = "";
            this.hospital = "";
            this.is_max_client = "";
            this.expert_ids = []
            this.is_cancle = 1
            this.page = 1;
            this.getList();
        },

        // 搜索
        search() {
            this.page = 1;
            this.getList();
        },
        // 返回上一页
        goBack() {
            window.history.go(-1);
            return;
        },
        getList() {
            let params = {
                servername: "Ruyi_AdminDoctorServices",
                method: "listing",
                params: {
                    user_name: this.user_name,
                    doctor_title: this.doctor_title,
                    hospital: this.hospital,
                    hospital_department: this.hospital_department,
                    is_visit_data: 1,
                },
                pageinfo: {
                    perpage: this.perpage,
                    page: this.page,
                },
            };

            this.$api.service(params).then((res) => {
                if (!check(res)) {
                    return;
                }
                for (var i = 0; i < res.data.data.list.length; i++) {
                    if (res.data.data.list[i].user_avatar) {
                        res.data.data.list[i].user_avatar =
                            this.imgUrl + res.data.data.list[i].user_avatar;
                    }
                }

                let tableData = res.data.data.list;
                let tableDataLen = tableData.length
                let week = '';
                let week_key = '';
                let header_class = '';
                let am_class = '';
                let pm_class = '';
                let am_department = '';
                let pm_department = '';
                let am_address = '';
                let pm_address = '';
                for (let i = 0; i < tableDataLen; i++) {
                    tableData[i].visits_data = []
                        for (let j = 0; j < this.week_day_array.length; j++) {
                            week_key = this.week_day_array[j]["key"];
                            week = this.week_day_array[j]["week"];
                            if (tableData[i].visit_dates && tableData[i].visit_dates[week_key]) {
                                if (!tableData[i].visit_dates[week_key]['上午']
                                    && !tableData[i].visit_dates[week_key]['下午']) {
                                    header_class = "visit_time time_header"
                                    am_class = "visit_time time_am n_selected"
                                    pm_class = "visit_time time_pm n_selected"
                                    am_department = ""
                                    pm_department = ""
                                    am_address = ""
                                    pm_address = ""
                                } else {
                                    header_class = "visit_time time_header selected"
                                }
                                if (tableData[i].visit_dates[week_key]['上午']) {
                                    am_class = "visit_time time_am selected"
                                    am_address = tableData[i].visit_dates[week_key]['上午'].address
                                    am_department = "";
                                } else {
                                    am_class = "visit_time time_am n_selected"
                                    am_department = ""
                                    am_address = ""
                                }
                                if (tableData[i].visit_dates[week_key]['下午']) {
                                    pm_class = "visit_time time_pm selected"
                                    pm_address = tableData[i].visit_dates[week_key]['下午'].address
                                    pm_department = "";
                                } else {
                                    pm_class = "visit_time time_pm n_selected"
                                    pm_address = ""
                                    pm_department = ""
                                }

                            } else {
                                header_class = "visit_time time_header"
                                am_class = "visit_time time_am n_selected"
                                pm_class = "visit_time time_pm n_selected"
                                am_department = ""
                                pm_department = ""
                                am_address = ""
                                pm_address = ""
                            }
                            tableData[i].visits_data.push({
                                week: week,
                                week_key: week_key,
                                header_class: header_class,
                                am_class: am_class,
                                pm_class: pm_class,
                                am_department: am_department,
                                pm_department: pm_department,
                                am_address: am_address,
                                pm_address:  pm_address,
                            })
                        }
                }

                this.tableData = res.data.data.list;
                this.total = res.data.data.page.count;

                localStorage.setItem('expert_list_user_name', this.user_name)
                localStorage.setItem('expert_list_doctor_title', this.doctor_title)
                localStorage.setItem('expert_list_hospital', this.hospital)
                localStorage.setItem('expert_list_hospital_department', this.hospital_department)
                localStorage.setItem('expert_list_is_max_client', this.is_max_client)
                localStorage.setItem('prev_page', 'expert_list')
                localStorage.setItem('page', this.page)
                localStorage.setItem('perpage', this.perpage)
                this.is_pagination_show = true
            });
        },

        //更换页码
        changePage(index) {
            this.page = index;
            this.getList();
        },

        // 改变每页条数
        changeSite(index) {
            this.perpage = index;
            this.getList();
        },

        // 获取所有单位
        getAllHospital() {
            let params = {
                servername: "Ruyi_AdminOperateServices",
                method: "getAllHospital",
            };

            this.$api.service(params).then((res) => {
                if (!check(res)) {
                    return;
                }
                this.allHospital = res.data.data;
            });
        },

        getAllDeparment() {
            let params = {
                servername: "Ruyi_AdminOperateServices",
                method: "getAllDeparment",
                params: {
                    hospital_id: this.hospital_id,
                },
            };

            this.$api.service(params).then((res) => {
                if (!check(res)) {
                    return;
                }
                this.allDeparment = res.data.data;
            });
        },

        getAllTitle() {
            let params = {
                servername: "Ruyi_AdminOperateServices",
                method: "getAllTitle",
            };

            this.$api.service(params).then((res) => {
                if (!check(res)) {
                    return;
                }
                this.allTitle = res.data.data;
            });
        },
        addVisitData() {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复提交',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            if (!this.visitForm.visit_time || !this.visitForm.address) {
                let msg = `是否确定取消 ${this.visitForm.user_name} ${this.visitForm.week}${this.visitForm.half}的出诊安排`
                this.$confirm(msg, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.visitForm.address = ""
                    this.visitSubmit()
                }).catch((e) => {
                    this.is_submit = false;
                })
            } else {
                this.visitSubmit()
            }

        },
        visitSubmit() {
            let params = {
                'servername': 'Ruyi_AdminDoctorServices',
                'method': 'editVisits',
                'params': {
                    expert_id: this.visitForm.expert_id,
                    visit_date: this.visitForm.visit_date,
                    half: this.visitForm.half,
                    address: this.visitForm.address,
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    this.is_submit = false;
                    return;
                }
                this.$message({
                    type: "success",
                    message: '出诊时间编辑成功！',
                    duration: 1500,
                });
                this.getList()
                this.visitVisible = false;
                this.is_submit = false;
            }).catch(() => {
                this.is_submit = false;
            })
        },
        selectShow(flg) {
            let select_dropdown = document.getElementsByClassName('el-select-dropdown')
            for (let i = 0; i < select_dropdown.length; i++) {
                if (select_dropdown[i].outerHTML.indexOf("data-flg")>0) {
                    select_dropdown[i].style.minWidth = '217px'
                }
            }
        },
        updateVisit(e) {
            if (!this.visitForm.visit_time) {
                let msg = `是否取消 ${this.visitForm.user_name} ${this.visitForm.week}${this.visitForm.half}的出诊安排`
                this.$confirm(msg, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.visitForm.visit_time = this.visitForm.week + this.visitForm.half
                    this.visitForm.address = ""
                    this.visitSubmit()
                }).catch((e) => {
                })
            }
            this.visitForm.visit_time = this.visitForm.week + this.visitForm.half
        },
    },
};

function get_device() {
    let ua = navigator.userAgent,
        isWindowsPhone = /(?:Windows Phone)/.test(ua),
        isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
        isAndroid = /(?:Android)/.test(ua),
        isFireFox = /(?:Firefox)/.test(ua),
        isChrome = /(?:Chrome|CriOS)/.test(ua),
        isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox &&
            /(?:Tablet)/.test(ua)),
        isPhone = /(?:iPhone)/.test(ua) && !isTablet,
        isPc = !isPhone && !isAndroid && !isSymbian;
    return {
        isTablet: isTablet,
        isPhone: isPhone,
        isAndroid: isAndroid,
        isPc: isPc
    };
}
</script>

<style lang="scss">
@import "@/styles/common.scss";

.docker_buttons {
    width: 100%;
    float: right;
    margin: 30px 0px 8px 0px;

    .el-button {
        width: 150px;
        height: 32px;
        line-height: 7px;
        float: right;
    }
}

.inputs .el-input {
    width: 100% !important;
}


.expertCard_wrap {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    //margin: 0 auto;
    .expertCard {
        width: 75%;
        border: 1px solid #f4f4f4;
        padding: 20px;
        margin-bottom: 15px;
        position: relative;
        .m-b-15 {
            margin-bottom: 15px;
        }

        .m-b-10 {
            margin-bottom: 10px;
        }

        .m-l-10 {
            margin-left: 10px;
        }
        .expert_checkbox {
            height: 14px;
            position: absolute;
            left: 0;
            top: 0;
            .el-checkbox__inner{
                width: 14px;border: 1px solid #bdbdbd;
                transform: translateY(-1px);
            }
        }
    }
}

#expert_photo > .el-dialog {
    width: 90%;
    min-width: auto;
    margin-top: 2vh !important;
    height: 96vh !important;

    .el-dialog__body {
        height: 92.5%;
        padding: 0 20px 10px !important;

        .el-carousel.el-carousel--horizontal {
            height: calc(100% - 104px);

            .el-carousel__container {
                height: 100% !important;

                .el-image {
                    height: 100%;

                    img {
                        max-height: 100%;
                        width: auto;
                        max-width: 100%;
                        height: auto;
                    }
                }
            }
        }
    }

}

.expert-list {
    .el-dialog__wrapper {
        overflow: hidden;
    }

    .el-dialog__body {
        padding: 10px 20px;
    }
}

.el-image-viewer__wrapper {
    z-index: 3000 !important;
}

.el-popup-parent--hidden {
    overflow: hidden;
}

.inputs .el-select {
    max-width: none !important;
}
.image_box {
    height: 100%;
    overflow: hidden;
    overflow-y: auto;
}
.el-avatar>img{
    width: 100% !important;
}
.el-col{
    margin-bottom: 10px;
    input{
        width: 100%;
    }
}
.btn-ma{
    padding-left: 10px !important;
    padding-right: 10px !important;
}
.el-loading-spinner .el-loading-text,.el-loading-spinner i{
    color: #ffc3c3;
}

.expert_visit_time_container {
    display: flex;
    flex-direction: row;
    padding: 10px;
    width: 100%;box-sizing: border-box;
    .visit_avatar_content{
        height: 24px;
        line-height: 24px;
        margin: 0;
        padding: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .visit_time_box {
        width: 11.3%;margin-right: 1%;
        box-sizing: border-box;font-size: 14px;
        .visit_time {
            cursor: default;
            &.edit{
                cursor: pointer;
                :hover{
                    background: #02a7f0;
                    color: #fff;
                    border-radius:5px;
                }
            }
            border-radius:5px;
            background: #e9e9e9;
            &.time_am{
                margin-top: 10px;
                &.edit:hover{
                    background: #ccedfc;
                    color: #02a7f0;
                    border-radius:5px;
                }
                &.selected {
                    background: #ccedfc;
                    color: #02a7f0;
                }
            }
            &.time_pm{
                margin-top: 5px;
                &.edit:hover{
                    background: #ccedfc;
                    color: #02a7f0;
                    border-radius:5px;
                }
                &.selected {
                    background: #ccedfc;
                    color: #02a7f0;
                }
            }
            &.selected {
                background: #02a7f0;
                color: #fff;
            }
            &.time_header{
                p{
                    height: 2em;
                    line-height: 2em;
                    margin-top: 0;
                    margin-bottom: 0;
                    &:first-child{
                        padding-top:7px;padding-bottom: 0;
                    }
                    &:last-child{
                        padding-top: 0;padding-bottom: 7px;
                    }
                }
            }
            &.history {
                cursor: not-allowed;
            }
            .department_name{
                height: 36px;
                line-height: 36px;
                font-size: 12px;
                transform: translateY(-8px);
                word-break: break-all;
                text-overflow: ellipsis;
                overflow: hidden;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
            }
            .address_name{
                height: 36px;
                line-height: 18px;
                font-size: 12px;
                transform: translateY(-8px);
                word-break: break-all;
                text-overflow: ellipsis;
                overflow: hidden;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
            }
            &.n_selected{
                line-height: 76px;
                height: 76px;
            }
        }
        &:nth-child(7n+8){
            margin-right: 0;
        }
    }
}
</style>

